import { render, staticRenderFns } from "./TimeTableSetup.vue?vue&type=template&id=759b0197&"
import script from "./TimeTableSetup.vue?vue&type=script&lang=js&"
export * from "./TimeTableSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports